import {
  ref,
  Ref,
  defineComponent,
  onUnmounted,
  createVNode,
  cloneVNode,
  Fragment,
  FunctionalComponent,
} from "vue";

let currentRefIndex = 0;
const refs: [Ref<number>, Ref[]?, Ref[]?, Ref[]?][] = [];
// const _refs: { [key: string]: [Ref<number>, Ref[]?, Ref[]?][] } = {};
const currentHookIndexList: [number, number, number, number] = [0, 0, 0, 0];

const wrapperComponent = defineComponent({
  setup: (props, context) => {
    const forceUpdate = ref(0);
    const forceUpdateId = Symbol("forceUpdate");
    refs.push([forceUpdate]);
    const slotKey = refs.length - 1;
    // slot.key = refs.length - 1;
    onUnmounted(() => {
      const refIndex = Number(slotKey);
      refs[refIndex].fill(undefined);
    });

    // onMounted(() => {
    //   const refIndex = Number(slotKey);
    //   refs[refIndex][3]?.forEach(()=> {

    //   })
    // });
    
    return () => {
      currentRefIndex = Number(slotKey);
      currentHookIndexList.fill(0);
      // hookIndexList[currentRefIndex] = [0, 0, 0]
      const slot = context.slots?.default?.()?.[0] || createVNode(Fragment);
      return cloneVNode(slot, {
        ...slot?.props,
        [forceUpdateId]: forceUpdate.value,
      });
    };
  },
});

export function getHooks(hookType: number) {
  const hooks = (refs[currentRefIndex][hookType] || []) as Ref[];
  refs[currentRefIndex][hookType] = hooks;
  const currentHookIndex = currentHookIndexList[hookType] || 0;
  // const currentHookIndex = hookIndexList[currentRefIndex][hookTypeIndex - 1] || 0;
  const ret: [Ref[], number] = [hooks, currentHookIndex];
  currentHookIndexList[hookType] = currentHookIndexList[hookType] + 1;
  // hookIndexList[refIndex][hookTypeIndex - 1] = hookIndexList[refIndex][hookTypeIndex - 1] + 1
  return ret;
}

export function useHOC<T>(component: FunctionalComponent<T>) {
  const hoc: FunctionalComponent<T> = function (props: Parameters<typeof component>[0], context: Parameters<typeof component>[1]) {
    return createVNode(
      wrapperComponent,
      { ...(props || {}) },
      {
        default: () => [createVNode(component, null, context?.slots?  {
          ...context.slots
        } : null)],
      }
    );
  };
  hoc.displayName = component.displayName;
  return hoc
}
